// Offers summary add offer items event
// Propagates adding of offer items and new shopping context from OfferSummary component to its wrapper
export const ADD_OFFER_ITEMS_EVENT = "addofferitemsevent";
